<template>
    <div class="out-container">
        <Form
            ref="cInfo"
            :model="cInfo"
            :rules="ruleValidate"
            :label-width="120"
        >
            <Row :gutter="20">
                <Col span="24">
                    <FormItem
                        label="合同即将到期"
                        prop="expireDay"
                        style="width: 250px"
                    >
                        <input-number
                            v-model="cInfo.expireDay"
                            placeholder
                            :allowDecimal="false"
                            :includeThousandsSeparator="false"
                        >
                            <span slot="append">天</span>
                        </input-number>
                    </FormItem>
                    <FormItem style="margin-top: -20px">
                        <span style="color: #aaaa"
                            >合同到期前N天，合同状态变成即将到期</span
                        >
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem
                        label="交租提醒提前"
                        prop="payRentDay"
                        style="width: 250px"
                    >
                        <input-number
                            v-model="cInfo.payRentDay"
                            placeholder
                            :allowDecimal="false"
                            :includeThousandsSeparator="false"
                        >
                            <span slot="append">天</span>
                        </input-number>
                    </FormItem>
                    <FormItem style="margin-top: -20px">
                        <span style="color: #aaaa"
                            >应付日期前N天自动发送交租提醒</span
                        >
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem
                        label="账户余额微信提醒"
                        prop="balanceRemind"
                        style="width: 250px"
                    >
                        <input-number
                            v-model="cInfo.balanceRemind"
                            placeholder
                            :includeThousandsSeparator="false"
                        >
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                    <FormItem style="margin-top: -20px">
                        <span style="color: #aaaa"
                            >租客水电余额低于该数值，将自动发送消息提醒</span
                        >
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem
                        label="预付最小充值金额"
                        prop="minAmount"
                        style="width: 250px"
                    >
                        <input-number
                            v-model="cInfo.minAmount"
                            placeholder
                            :includeThousandsSeparator="false"
                        >
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                    <FormItem style="margin-top: -20px">
                        <span style="color: #aaaa"
                            >租客充值水电费不得低于该数值</span
                        >
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem
                        label="小程序首页显示最近"
                        prop="nearDays"
                        style="width: 250px"
                    >
                        <input-number
                            v-model="cInfo.nearDays"
                            placeholder
                            :allowDecimal="false"
                            :includeThousandsSeparator="false"
                        >
                            <span slot="append">天</span>
                        </input-number>
                    </FormItem>
                    <FormItem style="margin-top: -20px">
                        <span style="color: #aaaa"
                            >房东手机端显示最近N天的账单统计数据</span
                        >
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div>
            <Button
                type="primary"
                @click="save"
                :loading="btnLoading"
                class="btmBtn"
            >
                保存
            </Button>
        </div>
    </div>
</template>

<script>
import { notifyDetail, notifyAdd, notifyUpdate } from '@/api/setting'
import { currency } from '_u/helper'
import { multiply } from '@/views/common/u-contract'

export default {
    components: {},
    data() {
        return {
            btnLoading: false,
            cInfo: {
                id: '',
                expireDay: 0,
                payRentDay: 0,
                balanceRemind: 0,
                minAmount: 0,
                nearDays: 0,
                firstSettle: '',
                secondSettle: '',
                ver: '',
            },
        }
    },
    computed: {
        ruleValidate() {
            return {}
        },
    },
    methods: {
        save() {
            this.btnLoading = true
            var formData = Object.assign({}, this.cInfo)
            formData.balanceRemind = multiply(formData.balanceRemind)
            formData.minAmount = multiply(formData.minAmount)

            if (this.cInfo.id) {
                notifyUpdate(formData)
                    .then((args) => this.$Message.success('保存成功'))
                    .then(() => {
                        return notifyDetail()
                    })
                    .then((args) => {
                        this.setData(args.data)
                    })
                    .finally(() => {
                        this.btnLoading = false
                    })
            } else {
                notifyAdd(formData)
                    .then((args) => this.$Message.success('保存成功'))
                    .then(() => {
                        return notifyDetail()
                    })
                    .then((args) => {
                        this.setData(args.data)
                    })
                    .finally(() => {
                        this.btnLoading = false
                    })
            }
        },
        setData(data) {
            if (data && data.entity) {
                var notifyData = data.entity
                Object.keys(this.cInfo).forEach(
                    (name) => (this.cInfo[name] = notifyData[name])
                )
                this.cInfo.balanceRemind = currency(
                    this.cInfo.balanceRemind / 100
                )
                this.cInfo.minAmount = currency(this.cInfo.minAmount / 100)
            }
        },
    },
    created() {},
    mounted() {
        Promise.all([notifyDetail()]).then((args) => {
            var [notify] = args
            if (notify && notify.data && notify.data.entity) {
                this.setData(notify.data)
            }
            return args
        })
    },
}
</script>
<style lang="less" scoped>
.out-container {
    width: 500px;
    margin: 50px auto;
    .btmBtn {
        width: 100px;
        margin: 0 0 0 120px;
    }
}
</style>
